(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["framelle-scroll-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('framelle-assembly')) {
  customElements.define('framelle-assembly', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.storageKey = 'framelle-assembly-drag-seen-v1';
      this.returning = false;
      try { this.returning = localStorage.getItem(this.storageKey) === '1'; } catch (_) {}
      this.chapters = [...this.querySelectorAll('.fas__chapter')];
      this.pieces = [...this.querySelectorAll('.fas__piece')];
      this.images = [...this.querySelectorAll('.fas__piece,.fas__final')];
      this.stage = this.querySelector('.fas__stage');
      this.startHint = this.querySelector('.fas__start');
      this.dock = this.querySelector('.fas__dock');
      this.slider = this.querySelector('.fas__slider');
      this.percent = this.querySelector('.fas__percent');
      this.frame = 0;
      this.ready = false;
      this.lastProgress = -1;
      this.remember = () => {
        try { localStorage.setItem(this.storageKey, '1'); } catch (_) {}
      };
      this.steps = {
        top: [.02,.31,14,-100,-28], left: [.05,.35,-115,10,-22],
        bottom: [.10,.39,-12,105,26], right: [.14,.43,115,-8,22],
        canvas: [.43,.66,0,0,-12], stay: [.68,.83,-8,-55,-8],
        co: [.75,.91,-48,28,-18], ol: [.79,.95,48,28,18]
      };
      this.schedule = () => {
        if (!this.frame && this.classList.contains('is-enhanced')) this.frame = requestAnimationFrame(() => this.render());
      };
      this.configure = () => {
        const enhanced = this.ready && !this.returning && !this.motion.matches && innerHeight >= 640;
        this.classList.toggle('is-enhanced', enhanced);
        this.style.setProperty('--fas-top-space',`${Math.min(180,Math.max(0,scrollY+this.getBoundingClientRect().top))}px`);
        this.dock.hidden = !enhanced;
        this.lastProgress = -1;
        this.schedule();
      };
      this.onInput = () => this.schedule();
      this.slider.addEventListener('input',this.onInput);
      addEventListener('resize',this.configure,{passive:true});
      this.motion.addEventListener('change',this.configure);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) {
          this.observer.disconnect();
          this.images.forEach(img => { img.loading = 'eager'; });
          Promise.all(this.images.map(img => img.decode())).then(() => {
            if (!this.isConnected) return;
            this.ready = true;
            this.configure();
          }).catch(() => {});
        }
      },{rootMargin:'900px'});
      this.observer.observe(this);
    }
    render() {
      this.frame = 0;
      if (!this.classList.contains('is-enhanced')) return;
      const p = Number(this.slider.value)/100;
      if (p === this.lastProgress) return;
      this.lastProgress = p;
      this.startHint.hidden = p > .12;
      this.slider.setAttribute('aria-valuetext',`Tablonun oluşumu yüzde ${Math.round(p*100)}`);
      this.percent.textContent = `${Math.round(p*100)}%`;
      this.style.setProperty('--progress',p);
      if (p >= .995) this.remember();
      this.style.setProperty('--final-opacity',Math.max(0,Math.min(1,(p-.95)/.045)));
      this.style.setProperty('--assembly-turn',`${-5*(1-p)}deg`);
      this.style.setProperty('--guide-opacity',Math.max(0,1-p*1.4));
      this.pieces.forEach(img => {
        const [start,end,x,y,angle] = this.steps[img.dataset.piece];
        const t = Math.max(0,Math.min(1,(p-start)/(end-start)));
        const ease = t*t*(3-2*t);
        img.style.setProperty('--piece-x',`${x*(1-ease)}%`);
        img.style.setProperty('--piece-y',`${y*(1-ease)}%`);
        img.style.setProperty('--piece-turn',`${angle*(1-ease)}deg`);
        img.style.setProperty('--piece-opacity',Math.min(1,t*5));
        img.style.setProperty('--piece-scale',img.dataset.piece==='canvas' ? .35+.65*ease : 1);
      });
      const phase = p < .39 ? 0 : p < .68 ? 1 : 2;
      this.chapters.forEach((chapter,i) => {
        chapter.style.setProperty('--chapter-opacity',i===phase ? 1 : 0);
        chapter.style.setProperty('--chapter-y',i===phase ? '0px' : '12px');
      });
    }
    disconnectedCallback() {
      removeEventListener('resize',this.configure);
      this.motion.removeEventListener('change',this.configure);
      this.slider.removeEventListener('input',this.onInput);
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
